// Coca-Cola Brand Colors - Matching React Native App Theme
export const CocaColaTheme = {
  // Primary brand colors
  primary: '#F40000',     // Coca-Cola Red
  primaryDark: '#B50000', // Darker red
  primaryLight: '#FF4444', // Lighter red
  
  // Secondary colors
  white: '#FFFFFF',
  black: '#000000',
  
  // UI colors
  background: '#F5F5F5',
  surface: '#FFFFFF',
  border: '#E0E0E0',
  
  // Text colors
  textPrimary: '#212121',
  textSecondary: '#757575',
  textOnPrimary: '#FFFFFF',
  textLight: '#9E9E9E',
  
  // Status colors
  success: '#4CAF50',
  successDark: '#2E7D32',
  warning: '#FF9800',
  error: '#F44336',
  info: '#2196F3',
  
  // Grid colors
  headerBg: '#F40000',
  headerText: '#FFFFFF',
  rowEven: '#FFFFFF',
  rowOdd: '#F5F5F5',
  rowHover: '#FFEBEE',
  
  // Button colors
  buttonPrimary: '#F40000',
  buttonPrimaryHover: '#B50000',
  buttonSecondary: '#757575',
  buttonSecondaryHover: '#424242',
  
  // Input colors
  inputBorder: '#E0E0E0',
  inputFocus: '#F40000',
  inputBackground: '#FFFFFF',
  
  // Shadow
  shadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  shadowHeavy: '0 4px 8px rgba(0, 0, 0, 0.2)',
};

export type ThemeType = typeof CocaColaTheme;